import { FC, ReactNode } from 'react';
import { css } from '@emotion/react';
import { ResizableBox } from 'react-resizable';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { useChatbotAssistant } from '../../provider/chatbot-assistant.provider';
import { BouncingLoader } from '../bouncing-loader';
import { ChatBody } from '../chat-body';
import { ChatInput } from '../chat-input';
import { AssistantHeader } from '../header';

export const ChatbotWidget: FC<{ dragHandle?: ReactNode }> = ({ dragHandle }) => {
  const { t } = useTranslation('aiOnboarding');
  const { isOpen, isMinimized, isSending, messages, sendMessage, toggleMinimized } = useChatbotAssistant();

  return (
    <ResizableBox
      width={324}
      height={isMinimized ? 72 : 320}
      minConstraints={[324, isMinimized ? 72 : 240]}
      maxConstraints={[600, 800]}
      css={[styles.container, !isOpen && styles.hidden]}
    >
      <>
        <AssistantHeader>
          <AssistantHeader.GradientBar>{dragHandle}</AssistantHeader.GradientBar>
          <AssistantHeader.HeaderBar>
            <AssistantHeader.Title>{t('Weave AI')}</AssistantHeader.Title>
            <AssistantHeader.PanelControls onMinimizeAction={toggleMinimized} />
          </AssistantHeader.HeaderBar>
        </AssistantHeader>
        {isMinimized ? null : (
          <>
            <ChatBody>
              {messages.length > 0 ? <ChatBody.ChatMessageList messages={messages} /> : <ChatBody.ChatWelcomeMessage />}
            </ChatBody>
            {isSending && <BouncingLoader containerStyles={{ marginLeft: theme.spacing(2) }} />}
            <ChatInput>
              <ChatInput.TextBox onSend={sendMessage} />
            </ChatInput>
          </>
        )}
      </>
    </ResizableBox>
  );
};

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    border-radius: ${theme.borderRadius.medium};
    border: 1px solid ${theme.colors.neutral20};
    overflow-y: auto;
    background-color: ${theme.colors.white};
  `,
  hidden: css`
    display: none;
  `,
};
